<template>
	<AppLayout :title="trans('admin.users.representatives.certificates.title')">
		<Empty v-if="groups.length === 0"/>
		<CardGrid v-else>
			<Card v-for="group in groups" :key="`group-${group.id}`" :title="group.years" :subtitle="transChoice('admin.users.representatives.count', group.representatives_count)">
				<template #badges>
					<Badge v-if="group.active" :color="Color.Green" active>{{ trans('general.active') }}</Badge>
					<Badge v-else :color="Color.Red">{{ trans('general.inactive') }}</Badge>
				</template>
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.representatives.certificates.show', group.id)">
						<i class="fa-solid fa-eye mr-2"/>
						{{ trans('general.view') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import {defineProps, type Ref, ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import {trans, transChoice} from 'laravel-vue-i18n'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type BoardRepresentativeGroup} from '@/Types/Association/Representatives/BoardRepresentativeGroup'

const props = defineProps<{
	groups:Array<BoardRepresentativeGroup>,
}>()

const groups:Ref<Array<BoardRepresentativeGroup>> = ref(props.groups)
</script>